export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-behance-cc0522b0e2ac8a4d9d5a7ccd8315fc2b.svg";